import {
    type PricingResourceItemType,
    type PricingResourceType,
    pricingResourceTypes,
} from "@/admin/prices/pricingResourceTypes.tsx";
import { WSelect, type WSelectStyleProps, type WSelectValueProps } from "@/components/forms/WSelect.tsx";

export interface ResourceTypeSelectProps
    extends WSelectStyleProps, WSelectValueProps<PricingResourceItemType, PricingResourceType> {
    usableTypes: PricingResourceType[];
}

export function ResourceTypeSelect({ ...props }: ResourceTypeSelectProps) {
    const { usableTypes } = props;

    const filteredItems = pricingResourceTypes.filter((obj) => usableTypes.includes(obj.type));

    return (
        <WSelect
            aria-label="Select location"
            items={filteredItems}
            getKey={(item) => item.type}
            getTextValue={(item) => item.title}
            {...props}
        >
            {(item) => item.title}
        </WSelect>
    );
}
